// Per-sport default search radii (meters). Tuned from real on-the-ground
// mapping feedback — earlier defaults were too generous and overlapped
// neighbouring courts. Keys must match the `sport_type` strings produced by
// the classifier / stored on `sport_courts.sport_type` (see SportCourt in
// `types/domain.ts`). Anything not listed falls back to FALLBACK_RADIUS.
export const SPORT_DEFAULT_RADII: Record<string, number> = {
  // Ball sports — small footprints
  basketball_court: 15,
  tennis_court: 12,
  padel_court: 12,
  volleyball_court: 10,
  beach_volleyball_court: 10,
  pickleball_court: 12,
  ping_pong_table: 10,
  petanque_court: 15,
  bocce_court: 15,
  netball_court: 15,
  handball_court: 15,

  // Soccer / football family — large pitches
  soccer_pitch: 50,
  rugby_pitch: 50,
  american_football_field: 50,
  field_hockey_pitch: 50,
  cricket_pitch: 50,
  ultimate_frisbee_field: 50,

  // Tracks
  running_track: 120,

  // Skate / parkour / street workout
  skateboard_park: 25,
  street_workout_area: 25,

  // Other
  baseball_diamond: 50,
  multi_sport_court: 30,
  ice_hockey_rink: 30,
  disc_golf_course: 60,
};

const FALLBACK_RADIUS = 30;

export const MIN_RADIUS = 5;
export const MAX_RADIUS = 200;

export const SPORT_LABELS: Record<string, string> = {
  soccer_pitch: "Soccer",
  tennis_court: "Tennis",
  padel_court: "Padel",
  basketball_court: "Basketball",
  volleyball_court: "Volleyball",
  running_track: "Running",
  baseball_diamond: "Baseball",
  rugby_pitch: "Rugby",
  field_hockey_pitch: "Field Hockey",
  cricket_pitch: "Cricket",
  skateboard_park: "Skateboarding",
  multi_sport_court: "Multi-sport",
  beach_volleyball_court: "Beach Volleyball",
  petanque_court: "Petanque",
  street_workout_area: "Street Workout",
  pickleball_court: "Pickleball",
  ping_pong_table: "Ping Pong",
  bocce_court: "Bocce",
  american_football_field: "American Football",
  netball_court: "Netball",
  handball_court: "Handball",
  ice_hockey_rink: "Ice Hockey",
  ultimate_frisbee_field: "Ultimate Frisbee",
  disc_golf_course: "Disc Golf",
};

export function getSportLabel(sportType: string): string {
  return (
    SPORT_LABELS[sportType] ??
    sportType
      .split("_")
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
      .join(" ")
  );
}

export function getDefaultRadius(sportType: string): number {
  return SPORT_DEFAULT_RADII[sportType] ?? FALLBACK_RADIUS;
}

export function getEffectiveRadius(
  sportType: string,
  storedRadius: number | null | undefined,
): number {
  if (storedRadius != null && storedRadius > 0) return storedRadius;
  return getDefaultRadius(sportType);
}
